import {FormattedMessage} from "react-intl";
import {FaMapMarkerAlt} from "react-icons/fa";
import {IoTime} from "react-icons/io5";
import {useSelector} from "react-redux";
import {contactMethodsLinks} from "@utils/types/contactMethodsTypes";
import SetInnerHtml from "@components/setInnerHtml";
import {Col, Row} from "reactstrap";

const ContactUs = ({data}) => {
    const workTime = useSelector(state => state.UI.general?.work_time);
    const addresses = useSelector(state => state.UI.general?.addresses);

    return (
        <>
            <div className="link-sections-section-title">
                <h4 className="link-sections-section-title-text">
                    <FormattedMessage id="contactUs"/>
                </h4>
            </div>

            <div className="link-sections-section-items align-items-start">
                {addresses?.length > 0 && addresses?.map(address => {
                    return (
                        <div className="link-sections-section-items-item align-items-start mt-1">
                            <div
                                className="d-flex"
                            >
                                <FaMapMarkerAlt/>
                                <p className="ml-1 w-fit" dangerouslySetInnerHTML={{
                                    __html: address?.text
                                }}/>
                            </div>
                        </div>
                    )
                })}
                <Row>
                    {data?.map((item) => (
                        <Col xs={12} md={12}>
                            <div key={item.id} className="link-sections-section-items-item">
                                <a
                                    href={contactMethodsLinks(item.type, item.value)}
                                    rel="noreferrer"
                                    target="_blank"
                                    title={`${item.title}: ${item.value}`}
                                    className="d-flex align-items-center"
                                >
                                    <SetInnerHtml html={item.icon}/>
                                    <div className="ml-1">
                                        {item.value}
                                    </div>
                                </a>
                            </div>
                        </Col>
                    ))}
                </Row>


                {workTime && (
                    <div className="link-sections-section-items-item align-items-start flex-column mt-1">
                        <div className="d-flex">
                            <IoTime/>

                            <div className="ml-1 w-fit">
                                <FormattedMessage id="workTime"/>
                                <p className=''>
                                    {workTime}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </>
    );
};

export default ContactUs;